import { useTranslation } from 'react-i18next';
import { usePostsCreateNew } from 'app/modules/posts/hooks/usePostsCreateNew';
import { useUser } from 'modules/user/userSelector';
import { getUserFirstTimeFlagStatus } from 'utils/user/firstTimeFlags';
import { FirstTimeFlagKey } from 'types/User';
import { ChecklistTaskHookResult } from 'app/modules/onboardingChecklist/types';

export const useCreateFirstPostTask = (): ChecklistTaskHookResult => {
  const { t } = useTranslation();
  const { createPost } = usePostsCreateNew();
  const { firstTimeFlags } = useUser();

  const hasCreatedPost = getUserFirstTimeFlagStatus(
    firstTimeFlags,
    FirstTimeFlagKey.FIRST_POST_CREATED,
  );

  return {
    task: {
      id: 'create-first-post',
      title: t('onboardingChecklist.tasks.createFirstPost.title'),
      description: t('onboardingChecklist.tasks.createFirstPost.description'),
      ctaLabel: t('onboardingChecklist.tasks.createFirstPost.cta'),
      isDone: hasCreatedPost,
      perform: () => createPost(),
    },
  };
};
